import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getBlockTypesForDeviation, getHighestPriorityBlockReasonForDeviation, } from '../../Moderation/redux/selectors';
import { BlockReasons } from '../../Moderation/redux/types';
var matureReasons = [BlockReasons.MatureAge, BlockReasons.MatureFilter];
export function useDeviationMatureFilter(deviation) {
    var blockReasons = useSelector(function (state) { var _a; return (_a = (deviation && getBlockTypesForDeviation(state, deviation))) !== null && _a !== void 0 ? _a : []; });
    var displayReason = useSelector(function (state) {
        return deviation && getHighestPriorityBlockReasonForDeviation(state, deviation);
    });
    var _a = useState(false), matureFilterDisabled = _a[0], setMatureFilterDisabled = _a[1];
    // reset mature filter override when deviation changes
    var _b = (deviation || {}).deviationId, deviationId = _b === void 0 ? 0 : _b;
    useEffect(function () {
        setMatureFilterDisabled(false);
    }, [deviationId]);
    var hasNonOverridableBlockReasons = blockReasons.some(function (reason) { return !matureReasons.includes(reason); });
    var hasOverridableMatureBlockReasons = blockReasons.some(function (reason) {
        return matureReasons.includes(reason);
    });
    var props = useMemo(function () { return ({
        showBlocked: hasNonOverridableBlockReasons ||
            (hasOverridableMatureBlockReasons && !matureFilterDisabled),
        overrideMatureFilter: function () { return setMatureFilterDisabled(true); },
        displayReason: displayReason,
    }); }, [
        hasNonOverridableBlockReasons,
        hasOverridableMatureBlockReasons,
        matureFilterDisabled,
        displayReason,
    ]);
    return props;
}
//# sourceMappingURL=useDeviationMatureFilter.js.map